import { FC } from 'react'

import { useCart } from '../../../../../app/_providers/CartProvider.client'
import { formatPlacementAttribute } from '../../../../../containers/EmbroideryContainer/utils/formatPlacementAttribute'
import { CartItem } from '../../../../../types/figs'
import { DigitizationSneakPeek } from '../../../../embroidery/EmbroiderySneakPeek/DigitizationSneakPeek'

import { LogoDigitizationPlaceholder } from './LogoDigitizationPlaceholder'

export const LogoDigitizationCartItem: FC<{ cartItem: CartItem }> = ({ cartItem }) => {
  const { removeItems } = useCart()
  if (cartItem.isPlaceholder) return <LogoDigitizationPlaceholder />

  const {
    effectivePrice,
    fullPrice,
    title,
    properties: {
      _logo_preview,
      logo_name,
      logo_color_option,
      logo_note,
      logo_placement,
      _embroidery_version,
    },
  } = cartItem

  const logoPlacement = formatPlacementAttribute(logo_placement, _embroidery_version)

  return (
    <DigitizationSneakPeek
      role='listitem'
      imgSrc={_logo_preview}
      logoName={logo_name ?? ''}
      logoPlacement={logoPlacement}
      logoColor={logo_color_option}
      logoNote={logo_note}
      effectivePrice={effectivePrice}
      fullPrice={fullPrice}
      title={title}
      removeItem={() => removeItems([cartItem.key])}
    />
  )
}
